import { useMemo } from 'react';

import { getApiErrorMessage } from '@sbv-clients/util-misc';

import { GridEmptyState } from '../../components/style/grid-empty-state';

// A table's empty state, or its load error in the same style (pass as the
// grid's noRowsOverlay slot).
export const useNoRowsOverlay = ({
  isError,
  error,
  emptyTitle = 'Nothing here yet',
}: {
  isError?: boolean;
  error?: unknown;
  emptyTitle?: string;
}) =>
  useMemo(
    () =>
      isError
        ? () => (
            // The API's message is the title (e.g. "No labor levels found").
            <GridEmptyState
              icon="error"
              title={getApiErrorMessage(error) || "Couldn't load this list"}
            />
          )
        : () => <GridEmptyState title={emptyTitle} />,
    [emptyTitle, error, isError]
  );
